import React from "react";
import { Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

import {
  HubHookFormInput,
  HubHookCustomersSelect,
  QuoteSelectForPart,
} from "../../../components";
import PartDetailsLocation from "./PartDetailsLocation";

const gap = "15px";
const columnGap = "10px";

const PartMainDetails = ({ locationId, quotes }) => {
  const { getValues } = useFormContext();
  const customerIds = getValues("details.customerIds");
  const { id: partIdParam } = useParams();
  const partId = partIdParam ? Number(partIdParam) : null;

  const defaultCustomers = customerIds?.map((l) => (!isNaN(l) ? l : l?.id));

  return (
    <Stack gap={gap} p="20px">
      <Typography variant="boldCaptionMain">Part Details</Typography>
      <Stack direction="row" gap={columnGap}>
        <HubHookFormInput
          name="details.partName"
          label="Part Name"
          placeholder="ex. Pocket"
          shouldUnregister={false}
          required
        />
        <HubHookFormInput
          name="details.partNumber"
          label="Part Number"
          placeholder="ex. 29-100C"
          shouldUnregister={false}
          required
        />
      </Stack>
      <Stack direction="row" gap={columnGap}>
        <HubHookFormInput
          name="details.weight"
          label="Part Weight"
          shouldUnregister={false}
          placeholder="ex. 4.55"
          endAdornment="lbs"
          isDecimal
          required
        />
        <HubHookFormInput
          name="details.lastSentPrice"
          label="Price"
          shouldUnregister={false}
          placeholder="ex. 4.55"
          startAdornment="$"
          isDecimal
          required
        />
        <QuoteSelectForPart
          partId={partId}
          name="details.quoteId"
          defaultQuotes={quotes}
        />
      </Stack>
      <HubHookCustomersSelect
        name="details.customerIds"
        defaultValue={defaultCustomers}
        shouldUnregister={false}
        isTag
      />

      <Typography variant="boldCaptionMain">Part Location</Typography>
      <PartDetailsLocation />
      <HubHookFormInput name="locationId" defaultValue={locationId} hidden />
    </Stack>
  );
};

export default PartMainDetails;
